import { IDestroyOptions, Text } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { NewsItemRankUp } from "./NewsItemRankUp";
import { TextWithUnderline } from "by/gamefactory/cityversetycoon/scenes/game/components/TextWithUnderline";
import { CurrencyType, NewsCurrencyComponent } from "../NewsCurrencyComponent";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { INewsItemOptions } from "./NewsItem";
import { CancellationToken } from "async/CancellationToken";
import { ILatestNewsController } from "../../controllers/ILatestNewsController";

export class NewsItemRankUpLandlord extends NewsItemRankUp {
    private static readonly BUILDING_RANK_UP_TEXT = 'BUILDING RANK UP TO RANK ';
    private static readonly YOU_WERE_REWARDED_TEXT = 'YOU WERE REWARDED WITH';
    private static readonly SEE_REWARDS_TEXT = 'SEE REWARDS SUMMARY HERE';

    private readonly newsController: ILatestNewsController;
    private readonly options: NewsItemRankUpLandlordOptions;
    private readonly cancellationToken: CancellationToken;

    private buildingRankUpText: Text;
    private youWereRewardedText: Text;
    private currencyComponent: NewsCurrencyComponent;
    private seeRewardsText: TextWithUnderline;

    public constructor(
        id: string, 
        newsResources: LatestNewsResourcePackage, 
        newsController: ILatestNewsController, 
        options: NewsItemRankUpLandlordOptions,
        cancellationToken: CancellationToken
    ) {
        super(id, newsResources);
        this.newsController = newsController;
        this.options = options;
        this.cancellationToken = cancellationToken;
        this.build();
        this.layout();
        this.seeRewardsText.on("pointerdown", this.onSeeRewardsClickHandle, this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.seeRewardsText.off("pointerdown", this.onSeeRewardsClickHandle, this);
        super.destroy(options);
    }

    private build(): void {
        this.buildingRankUpText = new Text(NewsItemRankUpLandlord.BUILDING_RANK_UP_TEXT + this.options.rankNumber, new NewsTextStyle());
        this.youWereRewardedText = new Text(NewsItemRankUpLandlord.YOU_WERE_REWARDED_TEXT, new NewsTextStyle());
        this.currencyComponent = new NewsCurrencyComponent(this.newsResources, this.options.currencyNumber, CurrencyType.COINS);
        this.seeRewardsText = new TextWithUnderline(NewsItemRankUpLandlord.SEE_REWARDS_TEXT, new NewsTextStyle(), 0, -12, 3);
        this.seeRewardsText.eventMode = 'static';
        this.addChild(this.buildingRankUpText, this.youWereRewardedText, this.currencyComponent, this.seeRewardsText);
    }

    private layout(): void {
        this.buildingRankUpText.position.set(277, 50);
        this.youWereRewardedText.position.set(277, 93);
        this.currencyComponent.position.set(578, 93);
        this.seeRewardsText.position.set(277, 135);
    }

    private async onSeeRewardsClickHandle(): Promise<void> {
        this.seeRewardsText.eventMode = 'auto';
        await this.newsController.updateLatestNewsInfo(this.id);
        await this.newsController.showRankUp(this.options.currencyNumber, this.options.buildingRankUpLevel, this.cancellationToken);
        this.seeRewardsText.eventMode = 'static';
    }
}

export class NewsItemRankUpLandlordOptions implements INewsItemOptions {
    public readonly rankNumber: number;
    public readonly currencyNumber: number;
    public readonly buildingRankUpLevel: number;

    public constructor(rankNumber: number, currencyNumber: number, buildingRankUpLevel: number) {
        this.currencyNumber = currencyNumber;
        this.rankNumber = rankNumber;
        this.buildingRankUpLevel = buildingRankUpLevel;
    }
}